/**
 * @fileoverview added by tsickle
 * Generated from: serializers/visit-rating.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { decimalOrEmptyField, modelSerializer, serializerField } from '../util/serializers';
import { visitRating } from '../models/visit-rating';
import { customerSerializer } from './customer';
import { visitSerializer } from './visit';
/** @type {?} */
export var visitRatingSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: visitRating,
    fields: {
        visit: (/** @type {?} */ (serializerField.create({
            serializer: visitSerializer,
            optional: true
        }))),
        tip_pounds: decimalOrEmptyField.create(),
        customer: (/** @type {?} */ (serializerField.create({
            serializer: customerSerializer,
            optional: true
        })))
    }
})))));
